import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
const images = require.context("../assets/images", false);

function Blog() {
	  const [posts, setPosts] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    fetch("https://luxurygoldentriangle.com/bkadmn/wp-json/wp/v2/posts?per_page=4&_embed")
      .then((res) => res.json())
      .then((data) => {
        setPosts(data);
      })
      .catch((error) => console.error("Error fetching posts:", error));
  }, []);
const NextArrow = ({ onClick }) => (
  <button className="custom-next" onClick={onClick}>
    <img src={images("./Forward.svg")} alt="next" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="custom-prev" onClick={onClick}>
    <img src={images("./backward.svg")} alt="prev" />
  </button>
);

 const sliderSettings = {
    dots: true,
    infinite: true,
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


 

  // Slick Settings (Mobile Only)
 
  if (posts.length === 0) return null;
  
	return (
		<div className="blog mt-80 paddingY-70">
	  <img className="top-left-position" src={images("./dance-man.svg")} />
	  <img className="bottom-right-position" src={images("./peacock.svg")} />
	  <div className="container">
        <div className="heading center">
          <h2>Latest Blogs</h2>
        </div>
        {isMobile ? (
  <Slider {...sliderSettings}>
    {posts.map((post) => (
      <div key={post.id}>
        <div className="blog-list-card mobile-slider-card">
          <Link to={`/${post.slug}`}>
            <img
              src={post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url}
              alt={post.title.rendered}
            />
          </Link>
          <div className="blog-list-card-content">
            <span>
              {post?._embedded?.author?.[0]?.name || "Admin"}
            </span>
            <Link to={`/${post.slug}`}>
              <h4
                dangerouslySetInnerHTML={{
                  __html: post.title.rendered,
                }}
              />
            </Link>
            <div className="author-detail">
              <p>by Admin</p>
              <p>
                <img src={images("./calender.svg")} />
                {new Date(post.date).toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    ))}
  </Slider>
) : (
		        <div className="row">
          {/* First Big Post */}
          <div className="col-md-6">
            {posts[0] && (
              <Link to={`/${posts[0].slug}`}>
              <div
                className="blog-big-card"
                style={{
                  backgroundImage: `url(${
                    posts[0]?._embedded?.["wp:featuredmedia"]?.[0]
                      ?.source_url
                  })`,
                  backgroundSize: "cover",
                }}
              >
                <div className="blog-big-card-content">
                  <span>
                    {posts[0]?._embedded?.author?.[0]?.name || "Admin"}
                  </span>
                  <h4
                    className="color-white"
                    dangerouslySetInnerHTML={{
                      __html: posts[0].title.rendered,
                    }}
                  />
                  <div className="author-detail color-white">
                    <p>by Admin</p>
                    <p>
                     <img src={images("./calender.svg")} /> {new Date(posts[0].date).toLocaleDateString()}
                    </p>
                  </div>
                </div>
              </div>
              </Link>
            )}
          </div>

          {/* Other 3 Posts */}
          <div className="col-md-6">
            {posts.slice(1).map((post) => (
              <div key={post.id} className="blog-list-card">
                <Link to={`/${posts[0].slug}`}>
                <img
                  src={
                    post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url
                  }
                  alt={post.title.rendered}
                /></Link>
                <div className="blog-list-card-content">
                  <span>
                    {post?._embedded?.author?.[0]?.name || "Admin"}
                  </span>
				  <Link to={`/${posts[0].slug}`}>
                  <h4
                    dangerouslySetInnerHTML={{
                      __html: post.title.rendered,
                    }}
                  />
				  </Link>
                  <div className="author-detail">
                    <p>by Admin</p>
                    <p>
                     <img src={images("./calender.svg")} /> {new Date(post.date).toLocaleDateString()}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
       
        </div>
)}
		</div>
	  </div>
	);
}

export default Blog;
